import React, {
  forwardRef,
  useImperativeHandle,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import FlipHorizontalIcon from "../crop/icons/FlipHorizontalIcon";
import RotateRightIcon from "../crop/icons/RotateRightIcon";
import RotateLeftIcon from "../crop/icons/RotateLeftIcon";
import FlipVerticalIcon from "../crop/icons/FlipVerticalIcon";
import RotateComponent from "../shape-editor/RotateComponent";
import "./Navigation.css";

const Navigation = forwardRef(
  (
    {
      className,
      buttonClassName,
      rotateComponentClassName,
      barClassName,
      highlightedBarClassName,
      activeBarClassName,
      zeroBarClassName,
      valueBarClassName,
      disabled,
      value,
      onRotate,
      onRotateEnd,
      onFlip,
    },
    ref
  ) => {
    const [quarter, setQuarter] = useState(0);
    const [adjustmentAngle, setAdjustmentAngle] = useState(0);
    const rotateComponentRef = useRef(null);

    useLayoutEffect(() => {
      const absRotate = Math.abs(value);

      let rotate;
      if (absRotate % 90 > 45) {
        rotate = (absRotate - (absRotate % 90) + 90) / 90;
      } else if (absRotate % 90 < 45) {
        rotate = (absRotate - (absRotate % 90)) / 90;
      } else {
        rotate = quarter;
      }
      rotate = Math.sign(rotate) * rotate;

      if (rotate !== quarter) {
        setQuarter(rotate);
      }
      setAdjustmentAngle(
        Math.sign(value) * (Math.abs(value) - Math.abs(rotate) * 90)
      );
    }, [value, quarter]);

    useImperativeHandle(ref, () => {
      return {
        refresh() {
          if (rotateComponentRef.current) {
            rotateComponentRef.current.refresh();
          }
        },
      };
    });

    const rotateTo = (angle) => {
      if (onRotate && !disabled) {
        onRotate(angle, {
          transitions: false,
          interaction: true,
          immediately: true,
        });
      }
    };

    const rotateLeft = () => {
      if (onRotate && !disabled) {
        if (adjustmentAngle > 0) {
          onRotate(-adjustmentAngle);
        } else if (adjustmentAngle < 0) {
          onRotate(-90 - adjustmentAngle);
        } else {
          onRotate(-90);
        }
      }
    };

    const rotateRight = () => {
      if (onRotate && !disabled) {
        if (adjustmentAngle > 0) {
          onRotate(90 - adjustmentAngle);
        } else if (adjustmentAngle < 0) {
          onRotate(-adjustmentAngle);
        } else {
          onRotate(90);
        }
      }
    };

    const flip = (horizontal, vertical) => {
      const evenQuarter = quarter % 2 === 0;
      onFlip?.(
        evenQuarter ? horizontal : vertical,
        evenQuarter ? vertical : horizontal,
        {
          normalize: false,
        }
      );
    };

    const flipHorizontal = () => {
      flip(true, false);
    };

    const flipVertical = () => {
      flip(false, true);
    };

    return (
      <div className={`telegram-navigation ${className || ""}`}>
        {/* <button
          className={`telegram-navigation__button ${buttonClassName || ""}`}
          onClick={flipHorizontal}
        >
          <FlipHorizontalIcon />
        </button> */}
        <button
          className={`telegram-navigation__button ${buttonClassName || ""}`}
          onClick={rotateRight}
        >
          <RotateRightIcon />
        </button>
        <RotateComponent
          ref={rotateComponentRef}
          className={`telegram-navigation__rotator ${
            rotateComponentClassName || ""
          }`}
          barClassName={barClassName}
          zeroBarClassName={zeroBarClassName}
          valueBarClassName={valueBarClassName}
          highlightedBarClassName={highlightedBarClassName}
          onChange={rotateTo}
          onBlur={onRotateEnd}
          from={-45}
          to={45}
          value={adjustmentAngle}
        />
        <button
          className={`telegram-navigation__button ${buttonClassName || ""}`}
          onClick={rotateLeft}
        >
          <RotateLeftIcon />
        </button>
        {/* <button
          className={`telegram-navigation__button ${buttonClassName || ""}`}
          onClick={flipVertical}
        >
          <FlipVerticalIcon />
        </button> */}
      </div>
    );
  }
);

Navigation.displayName = "Navigation";

export default Navigation;
